import { Box, Button, Stack } from '@mantine/core';

import { RelatedResourceError } from '@e-origin/shared';

import { classes } from '@styles';

interface IdentificationDetailsProps {
  onHide(): void;
  list: RelatedResourceError[];
}

export const IdentificationDetails: React.FC<IdentificationDetailsProps> = (props) => {
  const { onHide, list } = props;

  return (
    <>
      <Box p={15}>
        <Stack>
          {list.map((item, index) => (
            <li key={index}>{item.reason}</li>
          ))}
        </Stack>
      </Box>

      <Box className={classes.footer} onClick={onHide}>
        <Button variant="transparent">Close</Button>
      </Box>
    </>
  );
};
